__webpack_require__.p = "/templates/NEModules/earthquakes/latest/";